<template>
  <div class="w-full h-full">
    <el-input
      placeholder="请输入名称或者编号"
      v-model="searchKeyWord"
      size="small"
      clearable
      @keypress.enter.native="searchData()"
      class="icon-search__input mb-10px"
    >
      <i
        slot="append"
        class="el-icon-search cursor-pointer icon-search__input"
        @click="searchData()"
      ></i>
    </el-input>
    <el-table
      :data="tableData"
      highlight-current-row
      class="!h-[calc(100%-132px)] !w-full"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" type="index" width="60" :index="indexMethod"> </el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :label="item.label"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div
            v-if="item.type === 'ThreeDimensional'"
            @click="moveThreeD(scope.row)"
            class="cursor-pointer text-hex-00bcc8 truncate"
          >
            {{ scope.row[item.prop] }}
          </div>
          <div v-else class="truncate">
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="60">
        <template slot-scope="{ row }">
          <el-button
            type="defult"
            size="mini"
            @click="lookDetail(row)"
            class="cursor-pointer !text-blue-500 !h-24px !leading-h-24px"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="getTableData()"
      @current-change="getTableData()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="page.total"
      class="text-center"
    ></el-pagination>
    <operation-ticket-details
      v-if="operationDetailVis"
      @close="operationDetailVis = false"
      :title="title"
      :iframeUrl="iframeUrl"
    />
  </div>
</template>

<script>
// api
// import { MetalBIMApi } from '@wiz-api/huizhou2'

// metal default data
import { operationConfig } from './config'
import { isJSONObj } from '../../../assets/js/scene/scene'

const { config } = Wiz.globalSettings.dynamicModules.modules[
  'visualization-tongre-vulkan'
].config.cockpitDyw
// const metalbimapi = new MetalBIMApi()
const OperationTicketDetails = () => {
  return import('./OperationTicketDetails')
}

const smCrypto = require('sm-crypto')
const smCryptoKey = config.smCryptoKey
const userInfo = Wiz.AuthHooks.GetUserInfo()
const userAccount = userInfo.profile.preferred_username

export default {
  components: { OperationTicketDetails },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [
        // {
        //   ticketTypeName: '票类型名称123',
        // },
      ],
      tableLoading: true,
      title: '两票清单',
      id: '',
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      operationDetailVis: false,
      searchKeyWord: '',
      mockData: {
        code: 0,
        message: '操作成功',
        data: {
          totalCount: 1,
          items: [
            {
              id: '1381917465801416705',
              createId: '1381864275269718018',
              createTime: '2021-04-13T10:29:33.288185Z',
              lastModifyId: '1381864275269718018',
              lastModifyTime: '2021-04-16T06:15:51.349296Z',
              title: null,
              taskName: '测试操作票041301',
              taskNo: null,
              serialNo: null,
              state: 'WaitCommit',
              stateDescription: '待提交',
              beginTime: null,
              endTime: null,
              riskLevel: 'None',
              remark: '备注',
              workflowId: null,
              hasPermission: false,
              formKey: null,
              isSinglePersonOperation: false,
              ticketType: null,
              ticketTypeName: null,
              profession: null,
              workgroup: null,
              department: null,
              ppeCheck: null,
              ppeCheckTime: null,
              ticketTaskPersonas: [],
              ticketRatePersonas: null,
              allTicketTaskPersonas: [
                {
                  roleType: 'Operator',
                  roleTypeName: '操作人',
                  step: 1,
                },
                {
                  roleType: 'Guardian',
                  roleTypeName: '监护人',
                  step: 2,
                },
                {
                  roleType: 'Approver',
                  roleTypeName: '值长',
                  step: 3,
                },
              ],
              handOnBoardCount: 0,
              handOnCommonLockCount: 0,
              deviceInfo: {
                lockCabinetList: null,
                wireCabinetList: null,
              },
              fileList: null,
              dataSourceFrom: '3D',
              commandTime: null,
              commandCommander: null,
              commandReceiver: null,
              reportTime: null,
              reportCommander: null,
              reportReceiver: null,
              isFinished: false,
              commonLockList: null,
              boardInfoList: null,
              hasExpired: null,
              deviceAreaList: null,
            },
          ],
        },
        success: true,
        copyNodePtr: 0, // 暂存的节点
        copyMat: 0, // 暂存的材质
        defaultCameraInfo: null, // 默认视角参数
        clickInList: false,
      },
    }
  },
  watch: {
    transferProps: {
      handler(data) {
        this.page.pageNo = 1
        this.getTableData()
      },
      deep: true,
      immediate: true,
    },
    type: {
      handler(data) {
        this.page.pageNo = 1
        this.getTableData()
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    tableColumns() {
      return operationConfig.pipelineSecondaryLedger.tableHead
    },
    searchApi() {
      return operationConfig.pipelineSecondaryLedger.api
    },
  },
  async mounted() {
    this.defaultCameraInfo = await this.player.Native.Camera.currentParam() // 获取默认相机信息
    this.player.Native.ModelTree.EventSelectItemChanged.connect((e) => {
      if (!this.clickInList) {
        console.log(e, 'eeeeeee')
        this.getTableData(e?.code)
      }
      this.clickInList = false
    })
  },
  methods: {
    indexMethod(index) {
      if (index < 10) {
        return `0${index + 1}`
      }
      return index + 1
    },
    lookDetail(row) {
      const timeStamp = Date.now()
      const usernameStamp = `${userAccount}|${timeStamp}`
      const encryptStr = smCrypto.sm4.encrypt(usernameStamp, smCryptoKey)
      const workTicketDetailUrl = `/ticket/op-ticket/task/view/${row.id}`
      const encodedUrl = encodeURIComponent(workTicketDetailUrl)
      this.iframeUrl = `${config?.url}/#/authorize?encryptStr=${encryptStr}&r=${encodedUrl}`
      this.operationDetailVis = true
      this.title = `${row.taskName || ''}操作票`
      const deviceName = row.deviceName.split(',')[0]
      this.findNodeByCode(deviceName, true)
    },
    // 恢复上一个node的颜色
    async resetColor() {
      if (this.copyNodePtr !== 0 && this.copyNodePtr !== undefined && this.copyMat !== undefined) {
        await this.player.Native.NodeProxy.setNodeMaterial(this.copyNodePtr, this.copyMat)
      }
    },
    // 恢复相机
    async resetCamera() {
      await this.player.Native.Camera.moveTo(
        this.defaultCameraInfo.eye,
        this.defaultCameraInfo.target,
        this.defaultCameraInfo.up,
        1
      )
    },
    // 通过设备code定位设备区域
    async findNodeByCode(code, clickInList) {
      this.clickInList = clickInList
      await this.resetColor()
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(decodeURIComponent(code))
      if (codeInfo && codeInfo.nodePtr) {
        // 场景是以node的形式加载的
        console.log('codeInfo.nodePtr', codeInfo.nodePtr)
        await this.player.Native.Camera.moveToCode(decodeURIComponent(code), 1) // 相机跳转
        await this.player.Native.ModelTree.setSelectItem(codeInfo.item) // 模型选中
        this.copyNodePtr = codeInfo.nodePtr
        const mat = await this.player.Native.NodeProxy.getNodeMaterial(codeInfo.nodePtr) // 材质的指针句柄
        this.copyMat = await this.player.Native.NodeProxy.copyMaterial(mat) // 复制材质,暂存材质
        await this.player.Native.NodeProxy.setMaterialDiffuse(mat, 1253923583)
      } else {
        await this.resetCamera()
      }
    },
    async getTableData(deviceName) {
      this.tableLoading = true
      // const res = await axios.get(`${config.url}${operationConfig.pipelineSecondaryLedger.api}`, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'org-id': config.orgId,
      //     'token-id': config.tokenId,
      //   },
      // })

      axios({
        method: 'GET',
        url: `${config.url}${operationConfig.pipelineSecondaryLedger.api}?pageNumber=${
          this.page.pageNo
        }&pageSize=${this.page.pageSize}&filter=${this.searchKeyWord}&deviceName=${deviceName ||
          ''}`,
        headers: {
          'Content-Type': 'application/json',
          'tenant-name': config.tenantName,
          'org-id': config.orgId,
          'token-id': config.tokenId,
        },
        responseType: 'json',
      })
        .then((res) => {
          this.tableData = res.data.data.items
          this.page.total = res.data.data.totalCount
        })
        .catch((err) => {
          console.log(err)
        })
      this.tableLoading = false
      // const [err, data] = await metalbimapi[this.searchApi](this.page.pageNo, this.page.pageSize, {
      //   keyWord: this.metalBimChildKeyword,
      //   metalType: '管道二级台账',
      // })
      // if (!err && data) {
      //   this.tableData = _.map(data.items, (item) => {
      //     return {
      //       ...item,
      //       PrGroupType: this.transferProps.prGroupType,
      //       PrName: this.transferProps.prName,
      //       prCode: item.prCode,
      //       prName: item.prName,
      //     }
      //   })
      //   this.page.total = data.totalCount
      //   this.tableLoading = false
      // }
    },
    async searchData() {
      this.page.pageNo = 1
      await this.getTableData()
    },
  },
  async beforeDestroy() {
    await this.resetColor()
    this.copyNodePtr = 0
    this.copyMat = 0
    await this.resetCamera()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  min-width: 24px;
  margin: 0 5px;
  padding: 0 4px;
}
</style>
